const UploadingStatusImage = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
            <path
                d="M20.9727 6.78947C22.3607 6.89474 23.5456 7.49123 24.5273 8.57895C25.5091 9.63158 26 10.8947 26 12.3684C26 13.9123 25.4583 15.2456 24.375 16.3684C23.3255 17.4561 22.056 18 20.5664 18H6.5C4.70573 18 3.16536 17.3509 1.87891 16.0526C0.626302 14.7193 0 13.1228 0 11.2632C0 9.61403 0.558594 8.14035 1.67578 6.84211C2.82682 5.50877 4.19792 4.75439 5.78906 4.57895C6.5 3.21053 7.4987 2.10526 8.78516 1.26316C10.0716 0.421053 11.4766 0 13 0C14.8281 0 16.5208 0.666667 18.0781 2C19.6693 3.33333 20.6341 4.92982 20.9727 6.78947Z"
                fill="white"
            />
        </svg>
    );
};

export default UploadingStatusImage;
